import React, { useState } from 'react';
import TesterModal from '../Tester/tester';

const TesterPage = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="contact-area">
        <h2 className="text-center mt-5">Welcome to RIC Appointment</h2>
        <div className="text-center mt-4">
          <button className="btn btn-danger" onClick={() => setShowModal(true)}>
            Book Appointment
          </button>
        </div>
      </div>
      <TesterModal show={showModal} onHide={() => setShowModal(false)} />
    </>
  );
};

export default TesterPage;
